import useOtherOrgOrgUnitTeamNameData from '../../state/otherOrgOrgUnitTeamName/UseOtherOrgOrgUnitTeamNameData';

const useOtherOrgOrgUnitCombobox = () => {
  const { otherOrgOrgUnitTeamNameState } = useOtherOrgOrgUnitTeamNameData();

  return { otherOrgOrgUnitTeamNameState };
};

export default useOtherOrgOrgUnitCombobox;